"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCsrfToken = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const getCsrfToken = () => js_cookie_1.default.get("csrftoken") || "";
exports.getCsrfToken = getCsrfToken;
